import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Home, Package, Scissors, Box, PenTool, Users, Grid } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { UserRole } from '@/lib/types';

const allNavItems = [
  { path: '/dashboard', label: 'All Orders', icon: Home, roles: [UserRole.MANAGER, UserRole.ADMIN] },
  { path: '/dashboard/overview', label: 'Overview', icon: Grid, roles: [UserRole.MANAGER, UserRole.ADMIN, UserRole.KANBAN] },
  { path: '/dashboard/kitting', label: 'Kitting', icon: Package, roles: [UserRole.KITTING] },
  { path: '/dashboard/fabric', label: 'Fabric', icon: Scissors, roles: [UserRole.FABRIC] },
  { path: '/dashboard/metal', label: 'Metal', icon: PenTool, roles: [UserRole.POWDER] },
  { path: '/dashboard/assembly', label: 'Assembly', icon: Box, roles: [UserRole.ASSEMBLY] },
  { path: '/dashboard/users', label: 'Users', icon: Users, roles: [UserRole.USER_MANAGEMENT, UserRole.ADMIN] },
];

export function Navigation() {
  const location = useLocation();
  const { currentUser } = useAuth();

  const filteredNavItems = allNavItems.filter(item => {
    if (item.roles.length === 0) return true;
    if (!currentUser?.roles) return false;
    
    // For the All Orders tab, strictly check for manager or admin role
    if (item.path === '/dashboard' && item.label === 'All Orders') {
      return currentUser.roles.some(role => 
        role === UserRole.ADMIN || 
        role === UserRole.MANAGER
      );
    }
    
    // For other tabs, check if user has any of the required roles
    return currentUser.roles.some(role => 
      role === UserRole.ADMIN || 
      item.roles.includes(role)
    );
  });

  useEffect(() => {
    const currentTab = location.pathname.split('/').pop() || 'all';
    Cookies.set('lastActiveTab', currentTab, { expires: 30 });
  }, [location.pathname]);

  return (
    <nav>
      {/* Desktop Navigation */}
      <div className="hidden md:flex space-x-1 pt-2">
        {filteredNavItems.map(({ path, label, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              `px-4 py-3 text-sm font-medium rounded-t-xl transition-all duration-200 flex items-center gap-2 relative overflow-hidden group
              ${isActive 
                ? 'bg-white/95 text-slate-800 shadow-lg shadow-black/10 border-t border-x border-white/50 relative -mb-px scale-105' 
                : 'text-white/80 hover:text-white hover:bg-white/10 hover:scale-105 border border-transparent hover:border-white/20'
              }`
            }
            end
          >
            <Icon className="w-4 h-4 relative z-10" />
            <span className="relative z-10">{label}</span>
            {/* Animated background */}
                            <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-white/10 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-150 origin-left" />
          </NavLink>
        ))}
      </div>


    </nav>
  );
} 